import Schedules from "routes/schedule/schedules"
import { authoringRoute } from "../../authoring.runtime"
import { CompareDraft } from "./compare-draft"
// We actually think these are no longer necessary, but overrides here to be safe,
// import { ScheduleBackButton, ScheduleCrumbs, ScheduleCustomTags } from "slot-definitions"
// import { Frag } from "lib/@components/slot/frag"

authoringRoute.register(
    "schedules/compare/:destination/:source/:projectId",
    <Schedules $lazy>
        <CompareDraft $lazy />
    </Schedules>
)

// ScheduleCrumbs.plug(<Frag replace if={(c) => c.isAuthoring} />)
// ScheduleBackButton.plug(<Frag replace if={(c) => c.isAuthoring} />)
// ScheduleCustomTags.plug(<Frag replace if={(c) => c.isAuthoring} />)
